export default __webpack_public_path__ + "static/media/react-original.ccdf22cd.svg";